// Info: Import NPM Dependancies
import { STATUS_CODES } from "http";
import { useDispatch, useSelector } from "react-redux";

// Info: Import Local Dependancies
import { getAppSettings, setAuthToken, setErrorMessage } from "../store/sitecoreSlice";
import { useAxios } from "./axiosInterceptor";
import { getSessionToken, setSessionToken } from "./sessionStorage.utils";
import { useApiHeaders } from "./useApiHeaders";
import { useProxyServices } from "./useProxyService";


export const useChatStream = () => {
  let {
           
    plainHeader,
    authHeader
   
  } = useApiHeaders();
 
  const appSettings = useSelector(getAppSettings);
  const dispatch = useDispatch();
  const {authenticationApi} = useAxios()
  const proxyServiceApi = useProxyServices();
  let responseStartTime: any = new Date();
  const postMessage = async (
    payload: any,
    onStreamUpdate: (partialMessage: string) => void
  ) => {
    try {
      let response = await chatcall();
      if(response.status===401){     
        await  proxyServiceApi.refreshToken();
        const token = getSessionToken();
        if (token) {
         
          authHeader["unauthtoken"] = `Bearer ${token}`;
              
        }
       response= await chatcall();
      }
      if (!response.ok || !response.body) {
        
        const errorText = await response.text();
        throw new Error(
          `Failed to send message: ${response.status} ${response.statusText} - ${errorText}`
        );
      }

    
      const reader = response.body.getReader();
      let chunkCount = 0; // Ensure chunkCount is initialized
      let totalChunks = ""; // Initialize totalChunks
      let unformattedChunk = ""; // Initialize unformattedChunk
      let incompleteChunk = "";

      const processText = async ({ done, value }: any): Promise<any> => {
        if (done) {
          return totalChunks;
        }
        chunkCount++;
        if (chunkCount === 2) {
          let responseEndTime: any = new Date();
          let timeDiff = responseEndTime - responseStartTime;
          //console.log(`Second chunk received at ${timeDiff / 1000} s`);
        }
        const chunkString = new TextDecoder("utf-8").decode(value);
        incompleteChunk += chunkString;

        let braceStack = [];
        let jsonStartIndex = -1;

        for (let i = 0; i < incompleteChunk.length; i++) {
          if (incompleteChunk[i] === '{') {
            if (braceStack.length === 0) {
              jsonStartIndex = i;
            }
            braceStack.push('{');
          } else if (incompleteChunk[i] === '}') {
            braceStack.pop();
            if (braceStack.length === 0 && jsonStartIndex !== -1) {
              const jsonString = incompleteChunk.substring(jsonStartIndex, i + 1);
              try {
                const chunkData = JSON.parse(jsonString);
                if (chunkData?.choices[0]?.delta?.content) {
                  totalChunks += chunkData?.choices[0]?.delta?.content;
                  unformattedChunk += chunkData?.choices[0]?.delta?.content;
                  onStreamUpdate(unformattedChunk);
                }
              } catch (error) {
                //console.log("Error parsing chunk data:", error);
                //console.log("Chunk data at error:", jsonString);
              }
              jsonStartIndex = -1;
            }
          }
        }

        // Remove processed JSON objects from incompleteChunk
        if (braceStack.length === 0 && jsonStartIndex === -1) {
          incompleteChunk = '';
        } else if (jsonStartIndex !== -1) {
          incompleteChunk = incompleteChunk.substring(jsonStartIndex);
        }

        return reader.read().then(processText);
      };
      return reader.read().then(processText);

    } catch (error: any) {
      dispatch(setErrorMessage(error));
      return [];
    }

    

    async function chatcall() {
      const token = getSessionToken();
      if (token) {
       
        authHeader["unauthtoken"] = `Bearer ${token}`;
            
      }
      return await fetch(
        `${appSettings.applicationBaseUrl}${appSettings.chatAPI}`,
        //"http://localhost:8081/application/chatbot-service/v1/esg-support/chat",
        {
          method: "POST",
          headers: {
            ...authHeader,
            "Content-Type": "application/json",
            responseType: "stream",
          },
          body: JSON.stringify(payload),
        }
      );
    }
  };
  return { postMessage };
};



